import reduce from 'lodash/reduce';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Notification';

import entity from '../../entities/grants/entity';
import profileActions from '../../entities/profiles/actions';
import { setNotification } from '../../notification/actions';

const TYPES = {
  ...entity.TYPES,
  GRANT_CREATION: `${entity.name}/GRANT_CREATION`,
  GRANT_CREATION_SUCCESS: `${entity.name}/GRANT_CREATION_SUCCESS`,
  GRANT_CREATION_ERROR: `${entity.name}/GRANT_CREATION_ERROR`,
  GRANT_UPDATION: `${entity.name}/GRANT_UPDATION`,
  GRANT_UPDATION_SUCCESS: `${entity.name}/GRANT_UPDATION_SUCCESS`,
  GRANT_UPDATION_ERROR: `${entity.name}/GRANT_UPDATION_ERROR`,
  NEW_USER_DETAILS: `${entity.name}/NEW_USER_DETAILS`,
  NEW_USER_DETAILS_SUCCESS: `${entity.name}/NEW_USER_DETAILS_SUCCESS`,
  NEW_USER_DETAILS_ERROR: `${entity.name}/NEW_USER_DETAILS_ERROR`,
  NEW_USER_EXISTING_GRANTS: `${entity.name}/NEW_USER_EXISTING_GRANTS`,
  NEW_USER_EXISTING_GRANTS_SUCCESS: `${entity.name}/NEW_USER_EXISTING_GRANTS_SUCCESS`,
  NEW_USER_EXISTING_GRANTS_ERROR: `${entity.name}/NEW_USER_EXISTING_GRANTS_ERROR`,
  SET_IS_GRANTS_REFRESHING: `${entity.name}/SET_IS_GRANTS_REFRESHING`,
};

const options = {
  headers: {
    'X-Check-Roles': true,
  },
};

const createGrant = (employerKey, data) => async (dispatch) => {
  dispatch({ type: TYPES.GRANT_CREATION });
  try {
    const response = await entity.api.updateGrant(employerKey, data, options);
    dispatch({ type: TYPES.GRANT_CREATION_SUCCESS, payload: response });
    return null;
  } catch (error) {
    dispatch({ type: TYPES.GRANT_CREATION_ERROR, payload: error });
    dispatch(setNotification('An error occurred while adding the user', VARIANTS.INFO));
    throw error;
  }
};

const updateGrant = (employerKey, data) => async (dispatch) => {
  dispatch({ type: TYPES.GRANT_UPDATION });
  try {
    const response = await entity.api.updateGrant(employerKey, data, options);
    dispatch({ type: TYPES.GRANT_UPDATION_SUCCESS, payload: response });
    return null;
  } catch (error) {
    dispatch({ type: TYPES.GRANT_UPDATION_ERROR, payload: error });
    dispatch(setNotification('An error occurred while updating the user', VARIANTS.INFO));
    throw error;
  }
};

const getNewUserInfo = email => async (dispatch) => {
  dispatch({ type: TYPES.NEW_USER_DETAILS });
  try {
    let response = await dispatch(profileActions.getAllByEmail([email]));
    response = reduce(response, (result, value, key) => ({ [key.toLowerCase()]: value }), {});
    const data = response[email] || {};
    dispatch({ type: TYPES.NEW_USER_DETAILS_SUCCESS, payload: { key: data.key, email } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.NEW_USER_DETAILS_ERROR, payload: error });
    dispatch(setNotification('An error occurred while fetching profile information', VARIANTS.INFO));
    throw error;
  }
};

const getUserGrantsByIndexedKeys = query => async (dispatch) => {
  dispatch({ type: TYPES.NEW_USER_EXISTING_GRANTS });
  try {
    const response = await entity.api.getUserGrantsByIndexedKeys(query, options);
    dispatch({ type: TYPES.NEW_USER_EXISTING_GRANTS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.NEW_USER_EXISTING_GRANTS_ERROR, payload: error });
    dispatch(setNotification('An error occurred while fetching profile information', VARIANTS.INFO));
    throw error;
  }
};

const setIsGrantsRefreshing = isGrantsRefreshing => ({
  type: TYPES.SET_IS_GRANTS_REFRESHING,
  payload: isGrantsRefreshing,
});

export {
  TYPES,
  createGrant,
  updateGrant,
  getNewUserInfo,
  getUserGrantsByIndexedKeys,
  setIsGrantsRefreshing,
};

export default {
  TYPES,
  createGrant,
  updateGrant,
  getNewUserInfo,
  getUserGrantsByIndexedKeys,
  setIsGrantsRefreshing,
};
